import { render } from "./switch.md?vue&type=template&id=a4502682"
import script from "./switch.md?vue&type=script&lang=js"
export * from "./switch.md?vue&type=script&lang=js"
script.render = render

export default script